<template>
  <b-container fluid class="ps-0">
    <b-row>
      <b-col lg="3" xl="3" xxl="3" md="3" sm="2" class="staticleftsidebar" v-if="windowWidth > 545">
        <LeftBar pagename="IssueDetails" masterheading="Outbound Issue" v-model="Id" :storestatus="true"
          :listed="sidebardata" :paramValues="ParamValues" :loading="loading">
        </LeftBar>
        <a class="back-btn" @click="goToFirstPage">
          <img alt="Vue logo" class="back" src="../../../../../assets/Img/icons/backtoright.svg" width="125"
            height="125" />
        </a>
      </b-col>
      <b-col lg="9" xl="9" xxl="9" md="9" sm="10">
        <b-container>
          <b-row>
            <SidebarList v-if="loading" class="mt-3" />
            <b-col class="my-3" v-else>
              <BacktoPage :goback="$router.back" class="my-3" v-if="windowWidth <= 545"></BacktoPage>
              <div class="d-flex align-items-center justify-content-between">
                <Headerlayout :headertext="FromStoreName"></Headerlayout>
                <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div v-if="windowWidth > 545">
                <section v-if="items.length !== 0" class="details_collapse">
                  <DetailsBanner :details="data" :loading="loading" class="mb-4" />
                </section>
                <div class="field" v-if="uploadedTableList.length != 0">
                  <label class="mb-0">{{
                    $t("PurchaseRequest.QuotationFile")
                  }}</label>
                </div>
                <b-row>
                  <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
                    <div class="fileuploadcard my-2" :title="item.fileName">
                      <div>
                        <p class="filenametxt">{{ item.fileName }}</p>
                        <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                          view
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2" v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
                  <p class="fn14 fw500">Camp Details</p>
                  <b-col lg="6" md="6" class="campdetailscard">
                    <b-row>
                      <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                        <p class="light-txt">Institute name:</p>
                        <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
                      </b-col>
                      <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                        <p class="light-txt">Camp date:</p>
                        <p class="fn14 fw500">
                          {{ ObjCamp.FormattedCampDate }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="8" md="8" class="d-flex align-items-center gap-2 py-2">
                        <p class="light-txt">Camp type:</p>
                        <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
                      </b-col>
                      <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                        <p class="light-txt">Expected IP:</p>
                        <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                        <p class="light-txt">Camp name:</p>
                        <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
                      </b-col>
                      <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                        <p class="light-txt">Expected OP:</p>
                        <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Issue Details"
                    econtent="Issue Details" eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                  <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                    :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1"
                    responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                    :filters="filters">
                    <template v-slot:Add> </template>
                    <template v-slot:action="{ data }">
                      <span>
                        <EditIcon />
                        <DeleteIcon />
                      </span>
                    </template>

                    <template v-slot:Itemname1="{ data }">
                      <span>
                        {{ data.Itemname1 }}
                      </span>
                      <span class="spantxt">
                        {{ data.BarCode }}
                      </span>
                    </template>

                    <template v-slot:ExpiryDate="{ data }">
                      <span>
                        {{
                          data.ExpiryDate === "01-01-1900"
                            ? ""
                            : data.ExpiryDate
                        }}
                      </span>
                    </template>
                  </Tableview>
                </div>
              </div>
              <div v-if="windowWidth <= 545">
                <MobileLoader v-if="loading" v-for="item in 5" />
                <div v-if="!loading">
                  <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Issue Details"
                    econtent="Issue Details" eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                  <MobileViewCardHeader>
                    <template v-slot:mobilecard>
                      <div class="mobile-card" v-for="item in items">
                        <div class="d-flex align-items-center gap-1">
                          <p class="light-name">{{ item.RefNo }} /</p>
                          <p class="light-name">{{ item.ItemCode }} /</p>
                          <p class="light-name1">{{ item.HSNCode }}</p>
                        </div>
                        <p class="name">{{ item.Itemname1 }}</p>
                        <div class="d-flex align-items-center gap-2" v-if="item.batch">
                          <p class="light-name">Batch :</p>
                          <p class="small-name">{{ item.batch }}</p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Requested Quantity :</p>
                          <p class="small-name">
                            {{ item.ItemQuantity ? item.ItemQuantity : "0" }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Received Quantity :</p>
                          <p class="small-name">
                            {{
                              item.recivedQuantity ? item.recivedQuantity : "0"
                            }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <p class="light-name">Returns :</p>
                          <p class="small-name">
                            {{ item.Returns ? item.Returns : "0" }}
                          </p>
                        </div>
                      </div>
                    </template>
                  </MobileViewCardHeader>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  onUnmounted,
} from "vue";
import LeftBar from "../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import POTableview from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../../../modules/Inventory/pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../../modules/Inventory/Service/ManufacturerService";
import commonService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import WithoutStockService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import ManufacturerMasterTableview from "../../../../../modules/Inventory/pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ManufacturerItemMappingTable from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import SidebarList from "../../../../../components/SkeletonLoaderComponents/SidebarList.vue";
import DetailsBanner from "../../../../../modules/Inventory/components/Transaction/detailsbanner.vue";
import moment from "moment";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import Service from "../../../../../modules/Inventory/Service/StockOutService";
import StockInFileUploadServices from "../../../../../modules/Inventory/Service/StockInFileUploadService";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    // Rightsidebar,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ManufacturerItemMappingTable,
    Tableview,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    SidebarList,
    BacktoPage,
    DetailsBanner,
    CrystalReportPrintPopUp
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },

    propsParams: {
      type: Object,
    },
  },
  setup() {
    let loading = ref(false);

    let items: any = ref([]);
    let loading1 = ref(false);

    let sidebardata = ref([]);
    let Id = ref([]);
    const route = useRoute();
    let FromStoreName = ref("");
    let ToStoreName = ref("");
    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      tostoreid: "",
      RequesterName: "",
      id: ref(),
      date: ref(),
    });
    const paramValue = computed(() => {
      return route.query.param as string;
    });
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      IsShow(), IsShowByStockOutId();
    });
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    const router = useRouter();
    const routerChangeCount = ref(0);

    onBeforeRouteUpdate(() => {
      routerChangeCount.value++;
    });
    const goToFirstPage = () => {
      setupHistoryManagement(router, 5);
    };

    let ObjCamp: any = ref({
      CampDetailCard: false,
      IsCamp: false,
      CampId: ref(),
      InstituteName: "",
      CampName: "",
      CampType: "",
      CampDate: "",
      FormattedCampDate: "",
      ExpectedIP: "",
      ExpectedOP: "",
    });
    //Table List

    const headers = [
      // {
      //   header: "Doc Type",
      //   field: "DocType",
      // },

      {
        header: "Id",
        field: "RefNo",
        class: "smallwidth",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
        bodyclass: "boldclass ",

      },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth ",
        slot: "Itemname1",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: "Expiry Date",
        field: "ExpiryDate",
        slot: "ExpiryDate",
        fieldDisplay: "false",
        class: "smallwidth",
      },
      {
        header: "Batch",
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: "UOM",
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Req Qty",
        field: "RequestedQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Issued Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      //   {
      //     header: "Accepted Quantity",
      //     field: "",
      //      bodyclass: 'boldclass',
      //   },
      // {
      //   header: "Returns ",
      //   field: "",
      //   bodyclass: "boldclass",
      // },
      // { field: "action", header: "Action", slot: "action",
      // frozencolumn: true, sortable: false },
    ];
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    async function IsShow() {
      debugger;
      try {
        loading.value = true;

        let Flag = 1,
          searchOption = "";

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.FromStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        let response = await Service.listStockOutMasterTM(
          "",
          "",
          "",
          "",
          "10,11",
          "StoreId",
          Number(route.query.storeid),
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          Flag,
          searchOption,
          Condition
        );

        // response["result"] = response["result"].filter(
        //   (x) =>
        //     x.HospitalId == usersData.OrganizationId &&
        //     x.BranchId == usersData.BranchId
        // );

        // sidebardata.value = response["result"];

        // let response = await commonService.GetStockOutTMTableList(
        //   "10,11",
        //   ParamValues.value.StoreId,
        //   0
        // );
        sidebardata.value = response["result"];
        const oldKey1 = "ToStoreName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";
        const oldKey3 = "StockOutTransId";
        const newKey3 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
            [newKey3]: item[oldKey3],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          delete newItem[oldKey3];
          return newItem;
        });

        // console.log(sidebardata.value);
        // FromStoreName.value = response["result"][0].FromStoreName;
        // console.log(FromStoreName.value);

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    debugger;
    const ParamValues = ref({
      Id: 0,
      StoreId: 0,
    });
    // let manufacturerId = route.query.id;

    ParamValues.value.Id = Number(route.query.id);
    ParamValues.value.StoreId = Number(route.query.storeid);
    console.log(ParamValues.value.Id);
    watch(
      () => route.query.id,
      (newVal: any) => {
        debugger;

        ParamValues.value.Id = Number(newVal);
        ParamValues.value.StoreId = Number(newVal);

        console.log(ParamValues.value.Id);

        IsShowByStockOutId();
      }
    );
    let IssueId = ref("");
    let uploadedTableList: any = ref([]);
    let StockTransId = ref("");

    async function IsShowByStockOutId() {
      loading.value = true;
      debugger;
      try {
        console.log(ParamValues.value.Id);
        const result = await WithoutStockService.GetItemsByIssueIdDocType(
          ParamValues.value.Id
        );
        let message = result["ErrorInfo"].ErrorCode;
        if (message == null) {
          console.log(result["result"]);

          IssueId.value = result["result"][0].DocNo;
          items.value = result["result"];
          console.log(items.value);
          const totalIssueQty = computed(() => {
            return items.value.reduce(
              (sum, item: any) => sum + item.IssuedQty,
              0
            );
          });

          const totalItemQty = computed(() => {
            return items.value.reduce(
              (sum, item: any) => sum + item.ItemQuantity,
              0
            );
          });
          ToStoreName.value = result["result"][0].ToStoreName;
          data.value.fromstr = result["result"][0].FromStoreName;
          FromStoreName.value = result["result"][0].ToStoreName;
          data.value.tostr = result["result"][0].ToStoreName;
          data.value.fromstoreid = result["result"][0].FromStoreCode;
          data.value.tostoreid = result["result"][0].ToStoreCode;
          data.value.fromstatus = result["result"][0].FromStoreType;
          data.value.tostatus = result["result"][0].ToStoreType;
          data.value.fromcount = totalItemQty;
          data.value.tocount = totalIssueQty;
          data.value.id = result["result"][0].DocNo;
          data.value.date = result["result"][0].DocDateHR;
          data.value.RequesterName = result["result"][0].CreatedByName;
          StockTransId.value = result["result"][0].RefId;

          loading.value = false;
        }
        const FileUploadresult =
          await StockInFileUploadServices.getStockInFileById(
            ParamValues.value.Id
          );
        if (FileUploadresult["result"].length > 0) {
          for (let i = 0; i < FileUploadresult["result"].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] =
              FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
              (Fileobj["fileName"] =
                FileUploadresult["result"][i].FileName.split("/").pop()),
              (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
              (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
              (Fileobj["Id"] = FileUploadresult["result"][i].Id),
              uploadedTableList.value.push(Fileobj);
          }
        } else {
          uploadedTableList.value = [];
        }
        if (StockTransId.value) {
          await GetCampDetails();
        }
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    }
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }

    async function GetCampDetails() {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(
        StockTransId.value
      );
      if (result["result"][0].IsCamp) {
        ObjCamp.value.IsCamp = result["result"][0].IsCamp;
        ObjCamp.value.CampId = result["result"][0].CampId;
        ObjCamp.value.InstituteName = result["result"][0].InstituteName;
        ObjCamp.value.CampName = result["result"][0].CampName;
        ObjCamp.value.CampType = result["result"][0].CampType;
        ObjCamp.value.CampDate = result["result"][0].CampDate;
        ObjCamp.value.FormattedCampDate = moment(
          result["result"][0].CampDate,
          "MM/DD/YYYY hh:mm:ss A"
        ).format("DD/MM/YYYY");
        ObjCamp.value.ExpectedIP = result["result"][0].ExpectedIP;
        ObjCamp.value.ExpectedOP = result["result"][0].ExpectedOP;
        ObjCamp.value.CampDetailCard = true;
      }
    }

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 10,
      HeaderTitle: "OutBound Issue",
      ModuleId: 3,
    });

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ParamValues.value.Id;
      ParameterValues.value.BranchId = ObjData.BranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      sidebardata,
      paramValue,
      IsShow,
      Id,
      loading1,
      headers,
      globalFilterFields,
      filters,
      items,
      ParamValues,
      IssueId,
      loading,
      FromStoreName,
      ToStoreName,
      routerChangeCount,
      goToFirstPage,
      windowWidth,
      data,
      fileviewer,
      uploadedTableList,
      ObjCamp,
      GetCampDetails,
      Print,
      hidepopup,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}

.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}
</style>
